// 统一 HTTP 传输与错误类型。原 UniApp 版本使用 uni.request，网页版改为 axios，
// 但请求/响应结构与错误语义完全保持一致。
import axios from 'axios'

export const AUTH_TIMEOUT = 10000
export const MEDIA_TIMEOUT = 60000

export class AuthError extends Error {
  constructor(code, status = 0, retryAfter = 0) {
    super(code)
    this.name = 'AuthError'
    this.code = code
    this.status = status
    this.retryAfter = retryAfter
  }
}

export class ProfileError extends Error {
  constructor(code, status = 0) {
    super(code)
    this.name = 'ProfileError'
    this.code = code
    this.status = status
  }
}

export class CatalogError extends Error {
  constructor(code) {
    super(code)
    this.name = 'CatalogError'
    this.code = code
  }
}

export class BrandError extends Error {
  constructor(code) {
    super(code)
    this.name = 'BrandError'
    this.code = code
  }
}

export function validateOrigin(value, development) {
  if (!value) throw new AuthError('NOT_CONFIGURED')
  const match =
    /^(https?):\/\/(localhost|\[::1\]|(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)*[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)(?::(\d{1,5}))?$/.exec(
      value,
    )
  if (
    !match ||
    (match[3] && (+match[3] < 1 || +match[3] > 65535)) ||
    (match[1] === 'http' &&
      (!development || !['localhost', '127.0.0.1', '[::1]'].includes(match[2])))
  )
    throw new AuthError('INVALID_CONFIG')
  return value
}

export const isUuid = (x) =>
  typeof x === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(x)

/** 幂等操作编号：不使用 Math.random 回退，避免不同请求复用同一编号。 */
export function newOperationId() {
  if (!window.crypto || !window.crypto.getRandomValues) throw new AuthError('AUTH_SERVICE_UNAVAILABLE')
  const bytes = window.crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

/** request: {url, method, data, headers, responseType} → {status, data, headers} */
export async function httpTransport(request) {
  let response
  try {
    response = await axios({
      url: request.url,
      method: request.method,
      data: request.data,
      headers: request.headers,
      timeout: request.responseType === 'arraybuffer' ? MEDIA_TIMEOUT : AUTH_TIMEOUT,
      withCredentials: false,
      responseType: request.responseType === 'arraybuffer' ? 'arraybuffer' : 'json',
      validateStatus: () => true,
    })
  } catch (error) {
    const timeout =
      error && (error.code === 'ECONNABORTED' || /timeout/i.test(String(error.message || '')))
    throw new AuthError(timeout ? 'TIMEOUT' : 'NETWORK')
  }
  return { status: response.status, data: response.data, headers: response.headers || {} }
}

export function headerValue(headers, name) {
  const entry = Object.entries(headers || {}).find(([key]) => key.toLowerCase() === name.toLowerCase())
  return entry ? entry[1] : undefined
}

export const isRecord = (x) => !!x && typeof x === 'object' && !Array.isArray(x)
